/**
 * injectScript
 * @param src (required, string)
 * @param options (optional, object)
 * @returns {Promise}
 */
// TODO: all uses should be updated to rejectOnError (and then the current default can be removed here and in all uses).
function injectScript(src, _temp) {
  let {
    delay = 0,
    rejectOnError = false,
    elementAttributes = {},
    tag = 'head'
  } = _temp === void 0 ? {} : _temp;
  return new Promise((resolve, reject) => {
    // Handle empty src
    if (!src) {
      if (rejectOnError) {
        reject(new Error('Empty src attribute'));
      } else {
        resolve();
      }
      return;
    }

    // Create HTMLScriptElement
    const script = document.createElement('script');
    script.defer = true;
    script.type = 'text/javascript';
    script.src = src;

    // Add attributes to script element
    Object.entries(elementAttributes).forEach(argsArray => script.setAttribute(...argsArray));

    // Set up resolution/rejection of Promise
    script.onload = () => resolve(script);
    if (rejectOnError) {
      script.onerror = reject;
    }
    setTimeout(() => {
      // Add script element to DOM
      document.getElementsByTagName(tag)[0].appendChild(script);
    }, delay);
  });
}
export default injectScript;